import type { IHealthServiceProvider } from '#domain/health';
import ApiClient from '#infra/config/api.client';
import type { HealthType } from '#root/domain/health/health.schema';
import { healthSchema } from '#root/domain/health/health.schema';

export class HealthServiceProvider implements IHealthServiceProvider {
  async getHealthStatus(): Promise<HealthType> {
    const response = await ApiClient.get('/health');
    const { data, status } = response;
    return healthSchema.parse({ message: data.message, statusCode: status });
  }
}
